// context/ImprovedTrainerContext.js
import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from '../axiosConfig';

export const TrainerContext = createContext();

export const TrainerProvider = ({ children }) => {
    const [trainer, setTrainer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const validateToken = () => {
        const token = localStorage.getItem('jwt');
        if (!token || typeof token !== 'string' || token.length < 10) {
            throw new Error('Invalid or missing token');
        }
        return token;
    };

    const fetchTrainerData = useCallback(async () => {
        try {
            setLoading(true);
            setError('');

            const token = validateToken();
            const response = await axios.get('/api/v1/trainer/trainer-details', {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                timeout: 10000
            });

            if (response.data) {
                setTrainer(response.data);
            } else {
                throw new Error('No trainer data received');
            }
        } catch (err) {
            console.error('Failed to fetch trainer details:', err);

            if (err.response?.status === 401) {
                setError('Sesja wygasła. Zaloguj się ponownie.');
                localStorage.removeItem('jwt');
            } else if (err.response?.status === 403) {
                setError('Brak uprawnień dostępu.');
            } else if (err.code === 'ECONNABORTED') {
                setError('Przekroczono czas oczekiwania. Spróbuj ponownie.');
            } else {
                setError('Nie udało się pobrać danych trenera.');
            }
        } finally {
            setLoading(false);
        }
    }, []);

    const refreshTrainerData = useCallback(async () => {
        if (loading) return;
        await fetchTrainerData();
    }, [fetchTrainerData, loading]);

    useEffect(() => {
        fetchTrainerData();
    }, [fetchTrainerData]);

    const value = {
        trainer,
        loading,
        error,
        refreshTrainerData
    };

    return (
        <TrainerContext.Provider value={value}>
            {children}
        </TrainerContext.Provider>
    );
};